import * as actions from "../action.constants";

const initialState = {
  isLoading: false,
  inventoriesData: {},
};

const storeInventories = (state, action) => {
  return {
    ...state,
    inventoriesData: action.payload || {},
  };
};

const handlers = {
  [actions.STORE_INVENTORIES]: storeInventories,
};

export default (state = initialState, action) => {
  const handler = handlers[action.type];
  if (typeof handler === "undefined") return state;
  return handler(state, action);
};
